import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "20",
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.4 4.6001C17.3 4.5001 17.2 4.5001 17 4.5001C16.7 4.5001 16.5 4.5001 16.2 4.4001C14.5 4.0001 13.3 2.7001 13.2 1.0001V0.600098C13.2 0.300098 13 0.100098 12.7 0.100098H9.60001C9.30001 0.100098 9.10001 0.300098 9.10001 0.600098V13.1001C9.10001 14.3001 8.10001 15.2001 7.00001 15.2001C6.30001 15.2001 5.70001 14.9001 5.30001 14.4001C4.60001 13.5001 4.80001 12.1001 5.70001 11.4001C6.10001 11.1001 6.50001 11.1001 7.30001 11.1001C7.40001 11.1001 7.60001 11.1001 7.70001 11.0001C7.80001 10.9001 7.90001 10.8001 7.90001 10.6001V7.3001C7.90001 7.1001 7.70001 6.8001 7.50001 6.8001C5.90001 6.6001 4.30001 7.0001 3.10001 8.0001C2.00001 9.0001 1.20001 10.4001 1.00001 12.1001C0.700006 14.0001 1.40001 16.0001 2.70001 17.3001C3.90001 18.6001 5.60001 19.2001 7.20001 19.2001C8.80001 19.2001 10.4 18.6001 11.6 17.4001C12.8 16.2001 13.5 14.6001 13.5 12.9001V7.4001C14.7 8.0001 16 8.4001 17.3 8.4001C17.6 8.4001 17.8 8.2001 17.8 7.9001V4.9001C17.6 4.8001 17.5 4.7001 17.4 4.6001Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }